module.exports = __webpack_public_path__ + "img/bank.1b6354fe.svg";